export default __webpack_public_path__ + "static/media/cases6.3b8f7f9f.webp";